<template>
  <div class="bulk-submissions">
    <v-data-table
      :headers="columns"
      :items="submissions"
      :options.sync="tableOptions"
      :server-items-length="total"
      item-key="id"
      :items-per-page="options.itemsPerPage"
      :disable-pagination="loading"
      :footer-props="{
        'disable-pagination': loading,
        ...footerProps,
      }"
      :disable-sort="loading"
      class="elevation-0"
      :loading="loading"
      no-data-text="No bulk submissions found"
    >
      <template v-slot:[`item.id`]="{ item }">
        <Typography variant="body-2">{{ item.id }}</Typography>
      </template>

      <template v-slot:[`item.formName`]="{ item }">
        <Typography variant="body-2">{{ item.Form.name }}</Typography>
      </template>

      <template v-slot:[`item.errors`]="{ item }">
        <Typography variant="body-2">{{ item.BulkClaims.length }}</Typography>
      </template>

      <template v-slot:[`item.claimantsCount`]="{ item }">
        <Typography variant="body-2">{{ uniqueClaimantsCount(item) }}</Typography>
      </template>

      <template v-slot:[`item.updateDate`]="{ item }">
        <Typography variant="body-2">{{ formatDate(item.updateDate) }}</Typography>
      </template>

      <template v-slot:[`item.updatedByName`]="{ item }">
        <Typography variant="body-2">{{ item.updatedByName }}</Typography>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex justify-end align-center">
          <Button
            icon
            text
            color="darkGrey"
            class="mr-1"
            @click="$emit('edit-submission', item)"
            :disabled="loading"
          >
            <v-icon>mdi-pencil</v-icon>
          </Button>
          <Button
            icon
            text
            color="darkGrey"
            @click="$emit('delete-submission', item)"
            :disabled="loading"
          >
            <v-icon>mdi-delete</v-icon>
          </Button>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from "moment";
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
export default {
  name: "BulkSubmissions",
  components: {
    Typography,
    Button,
  },
  props: {
    submissions: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => ({ page: 1, itemsPerPage: 10 }),
    },
    footerProps: {
      type: Object,
      default: () => ({}),
    },
    total: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columns: [
        { text: "Bulk Submission ID", value: "id", sortable: false },
        { text: "Form Name", value: "formName", sortable: false },
        { text: "Errors", value: "errors", sortable: false },
        { text: "Claimants", value: "claimantsCount", sortable: false },
        { text: "Last Updated", value: "updateDate", sortable: false },
        { text: "Last Updated By", value: "updatedByName", sortable: false },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    tableOptions: {
      get() {
        return this.options;
      },
      set(value) {
        this.$emit("update:options", value);
      },
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("MMM D, YYYY h:mm A");
    },
    uniqueClaimantsCount(item) {
      const claims = item.BulkClaims || [];
      const emails = new Set(
        claims
          .map((c) => (c.claimantEmail ?? "").toString().toLowerCase().trim())
          .filter((e) => e !== "")
      );
      return emails.size;
    },
  },
};
</script>

<style scoped>
.bulk-submissions {
  width: 100%;
}

.bulk-submissions ::v-deep .v-data-table {
  border: 1px solid #e0e0e0;
}

.bulk-submissions ::v-deep thead tr {
  background-color: #eeeeee;
}

.bulk-submissions ::v-deep thead th {
  color: black !important;
}

.bulk-submissions ::v-deep tbody tr td {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}
</style>
